module.exports = __webpack_public_path__ + "img/map.b4cab064.jpg";